/* eslint-disable react/jsx-props-no-spreading */
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { getFormatValues } from '../../../lib/utils';

import PageMeta from '../../partials/PageMeta';
import Header from '../partials/Header';
import Menu from '../partials/Menu';
import Sections from '../partials/Sections';
import sections from '../sections';

import '../../../../styles/guest/index.scss';
import styles from '../../../../styles/guest/pages/home.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const HomeGuestPage = ({ className }) => {
    const url = useUrlGenerator();
    const { locale } = useIntl();

    const [currentSectionIndex, setCurrentSectionIndex] = useState(null);
    const [scrollToIndex, setScrollToIndex] = useState(null);
    const sectionsCount = sections.length;
    const currentSection =
        currentSectionIndex < sectionsCount ? sections[currentSectionIndex] : null;
    const { theme = null } = currentSection || {};
    const isDarkMenu = theme === 'dark' || theme === 'black' || theme === 'primary';

    const onSectionChanged = useCallback(
        (sectionIndex) => {
            setCurrentSectionIndex(sectionIndex);
        },
        [setCurrentSectionIndex, scrollToIndex],
    );

    const onMenuItemClick = useCallback(
        (sectionIndex) => {
            setScrollToIndex(sectionIndex);
        },
        [setScrollToIndex],
    );

    const onLogoClick = useCallback(() => {
        setScrollToIndex(0);
    }, [setScrollToIndex]);

    const onContactClick = useCallback(() => {
        setScrollToIndex(sectionsCount - 1);
    }, [setScrollToIndex, sectionsCount]);

    useEffect(() => {
        if (scrollToIndex !== null) {
            setScrollToIndex(null);
        }
    }, [scrollToIndex]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <PageMeta fullTitle="Micromag" />
            <Header
                className={styles.header}
                withLogo={currentSectionIndex > 0}
                onLogoClick={onLogoClick}
                onContactClick={onContactClick}
            />
            <Menu
                className={styles.menu}
                currentIndex={currentSectionIndex}
                count={sectionsCount}
                dark={isDarkMenu}
                onItemClick={onMenuItemClick}
            />
            <Sections
                className={styles.content}
                currentIndex={currentSectionIndex}
                scrollToIndex={scrollToIndex}
                onChange={onSectionChanged}
                sectionProps={{
                    onContactClick,
                }}
            />
            <Link
                href={`${url('register')}?locale=${locale}`}
                external
                target="_self"
                className={classNames([
                    styles.cta,
                    { [styles.hidden]: currentSectionIndex === sectionsCount - 1 },
                ])}
            >
                <span className={styles.icon}>
                    <FontAwesomeIcon icon={faPlusCircle} />
                </span>
                <span className={styles.label}>
                    <FormattedMessage
                        defaultMessage="Create your first Micromag"
                        description="Guest content - CTA"
                        values={getFormatValues()}
                    />
                </span>
            </Link>
        </div>
    );
};

HomeGuestPage.propTypes = propTypes;
HomeGuestPage.defaultProps = defaultProps;

export default HomeGuestPage;
